'use strict';

module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/chart.js/src/charts/Chart.Bubble.js
// module id = ../../../../chart.js/src/charts/Chart.Bubble.js
// module chunks = 5